namespace TabAurous.Scheme {
    export interface SchemeEnrollmentForm {
        POSCustomerId: Serenity.ServiceLookupEditor;
        SchemeId: Serenity.LookupEditor;
        SchemeAmount: Serenity.IntegerEditor;
        BonusValue: Serenity.DecimalEditor;
        IsCancelled: Serenity.BooleanEditor;
        IsMatured: Serenity.BooleanEditor;
        IsRedeemed: Serenity.BooleanEditor;
        Tenure: Serenity.IntegerEditor;
    }

    export class SchemeEnrollmentForm extends Serenity.PrefixedContext {
        static formKey = 'Scheme.SchemeEnrollment';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SchemeEnrollmentForm.init)  {
                SchemeEnrollmentForm.init = true;

                var s = Serenity;
                var w0 = s.ServiceLookupEditor;
                var w1 = s.LookupEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.BooleanEditor;

                Q.initFormType(SchemeEnrollmentForm, [
                    'POSCustomerId', w0,
                    'SchemeId', w1,
                    'SchemeAmount', w2,
                    'BonusValue', w3,
                    'IsCancelled', w4,
                    'IsMatured', w4,
                    'IsRedeemed', w4,
                    'Tenure', w2
                ]);
            }
        }
    }
}
